<template>
  <div class="row" v-if="working">
    <div class="col text-center mt-5">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
  <div class="row" v-else>
    <div class="col">
      <table class="table">
        <thead>
          <tr>
            <th class="border-0 text-uppercase">{{ 'Name' | translate }}</th>
            <th class="border-0 text-uppercase">{{ 'Email' | translate }}</th>
            <th class="border-0 text-uppercase">
              {{ 'Progress' | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="students.length === 0">
            <td colspan="3">
              <div class="col text-center">
                <img
                  class="w-25 mt-5 mb-3"
                  src="/images/undraw_empty_xct9.svg"
                  alt=""
                />
                <h3 class="fw-light">
                  {{ 'Oops... Nothing here yet' | translate }}
                </h3>
              </div>
            </td>
          </tr>
          <tr v-for="student in students" :key="student.id">
            <td>{{ student.name }}</td>
            <td>{{ student.email }}</td>
            <td class="w-50">
              <div class="progress">
                <div
                  class="progress-bar"
                  role="progressbar"
                  :style="
                    `width: ${percent(
                      student.completed_lectures_count,
                      course.lectures_count,
                    )}%`
                  "
                  :aria-valuenow="
                    percent(
                      student.completed_lectures_count,
                      course.lectures_count,
                    )
                  "
                  aria-valuemin="0"
                  aria-valuemax="100"
                >
                  {{
                    percent(
                      student.completed_lectures_count,
                      course.lectures_count,
                    )
                  }}%
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ['course'],
  data() {
    return {
      students: [],
      working: true,
    }
  },
  methods: {
    handleError(error) {
      iziToast.error({
        title: 'Error',
        message: this.$t('Something went wrong'),
        position: 'bottomLeft',
      })
      console.error(error)
    },
    percent(completed, all) {
      return Math.round((completed / all) * 100)
    },
    getStudents() {
      return axios.post(`/home/courses/${this.course.id}/stats/students`)
    },
  },
  mounted() {
    this.getStudents()
      .then(({ data }) => {
        this.students = data
        this.working = false
      })
      .catch(this.handleError)
  },
}
</script>

<style></style>
